import React from 'react';

import { useSelector } from 'react-redux';

import { pageDataSelector } from 'store/page/selectors';
import { appHasChangesSelector } from 'store/unsavedChanges/selectors';

import { PageLanding, PageLandingWithAI } from '../PageLanding';
import { SceneFooter } from '../SceneFooter';
import { SceneLoaderWrapper } from '../SceneLoaderWrapper';
import { CommonModalData } from '../types';

export type Props = {
  modalData: CommonModalData;
  withAIActions?: boolean;
};

function PageScene({ modalData, withAIActions }: Props) {
  const { data, updateData, previousStep, handlePageSubmit } = modalData;
  const isPageHasChanges = useSelector(appHasChangesSelector);
  const defaultPage = data['page'];
  const page = useSelector(pageDataSelector);

  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!page) return;
    updateData('details', page);
  }, [page]);

  const onSubmit = async () => {
    setLoading(true);
    await handlePageSubmit();
    setLoading(false);
  };

  const pageLanding = React.useMemo(() => {
    if (!defaultPage) return null;
    if (withAIActions) return <PageLandingWithAI page={defaultPage} />;

    return <PageLanding page={defaultPage} />;
  }, [withAIActions, defaultPage]);

  return (
    <SceneLoaderWrapper loading={loading}>
      {pageLanding}

      <SceneFooter
        onSubmit={onSubmit}
        loading={loading}
        goBack={previousStep}
        type="primary"
        submitButtonLabel="Save"
        withTooltipDialog={isPageHasChanges}
      />
    </SceneLoaderWrapper>
  );
}

export { PageScene };
